import { render, staticRenderFns } from "./Joborder.vue?vue&type=template&id=5a15bd6a"
import script from "./Joborder.vue?vue&type=script&lang=js"
export * from "./Joborder.vue?vue&type=script&lang=js"
import style0 from "./Joborder.vue?vue&type=style&index=0&id=5a15bd6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports